import { Row } from 'antd';
import { t } from 'i18next';
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { LocationState } from 'types';
import { camelToKebabCase } from 'utils/camelToKebabCase';

import { DocumentModel, DOCUMENT_TYPE } from 'api/documents/documents.model';
import { USER_ROLE } from 'api/users/users.model';
import Button from 'components/Buttons';
import ProtectedComponent from 'components/ProtectedComponent';
import { TabItem, TabMenu } from 'components/TabMenu';
import { TablePage } from 'components/TablePage';
import { useCertificatesQuery } from 'hooks/useCertificatesQuery';
import { CertificateDetailsModel } from 'models/certificate.model';

import List from './List';
import useTableConfig from './useConfig';

const SalesDepartmentsPage = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { categoryByTabs, creationEnabledByTabs, configByTabs } = useTableConfig();
  const tabs = Object.keys(categoryByTabs);
  const [selectedTab, setSelectedTab] = useState((state as LocationState)?.selectedTab || tabs[0]);

  const handleCreateClick = () => {
    navigate(`/home/sales-departments/new/${camelToKebabCase(categoryByTabs[selectedTab])}`, {
      state: { selectedTab },
    });
  };

  return (
    <>
      <TabMenu selectedKeys={[selectedTab]}>
        {tabs.map((tab) => (
          <TabItem onClick={() => setSelectedTab(tab)} key={tab}>
            {t(`certificate.${tab}`)}
          </TabItem>
        ))}
      </TabMenu>
      {creationEnabledByTabs[selectedTab] && (
        <Row justify="end">
          <ProtectedComponent
            role={(Object.keys(USER_ROLE) as USER_ROLE[]).filter((r) => r !== USER_ROLE.VISITOR)}
          >
            <Button type="primary" onClick={handleCreateClick}>
              {t('document.create')}
            </Button>
          </ProtectedComponent>
        </Row>
      )}

      <TablePage<DocumentModel<CertificateDetailsModel>>
        request={useCertificatesQuery}
        tableComponent={List}
        tableProps={{ selectedTab, tableConfig: configByTabs[selectedTab] }}
        defaultParams={{
          documentType: DOCUMENT_TYPE.PRIVATE,
          categoryName: categoryByTabs[selectedTab],
        }}
      />
    </>
  );
};

export default SalesDepartmentsPage;
